import axiosInstance from '../helpers/axiosInstance'

// The server bounds the WP09 POST at 12s and the token leg at 8s, inside a 25s
// rack-timeout budget. 30s here so the client is never the first to give up —
// a client-side abort leaves the operator unable to tell whether SAP was reached.
const REQUEST_TIMEOUT_MS = 30_000

const BASE = `${process.env.REACT_APP_PLATFORM_URL}/api/v1/natura-operations/picking-confirmations`

export const previewPickingConfirmation = async params => {
  const { data } = await axiosInstance.post(`${BASE}/preview`, params, { timeout: REQUEST_TIMEOUT_MS })
  return data
}

export const resendPickingConfirmation = async ({ orderId, excludedDelivItems, addedEntries, expectedDigest }) => {
  const { data } = await axiosInstance.post(
    `${BASE}/resend`,
    {
      order_id: String(orderId),
      excluded_deliv_items: excludedDelivItems,
      // Only the four fields the platform reads: the id is local bookkeeping for the rows on
      // screen and has no meaning in the payload SAP receives.
      added_entries: (addedEntries || []).map(({ deliv_item, sku, batch, dlv_qty }) => ({ deliv_item, sku, batch, dlv_qty })),
      expected_digest: expectedDigest,
    },
    { timeout: REQUEST_TIMEOUT_MS },
  )
  return data
}
